import { cronosClient, odinClient } from "@/config/client"

export default function updateClientToken(token: string) {
  odinClient.updateToken(token)
  cronosClient.updateToken(token)
}
